const searchForm = $('#searchForm');
const photoContainer = $('#photoContainer');
let page = 0;

searchForm.find('img').on('click', () => searchForm.submit())

const getPhotos = (query, page) => {
    return fetch(`/process/card/library/photo?query=${query}&page=${page}`)
        .then(request => request.json())
}

const renderPhoto = (query) => {
    const row = $('<div />')
        .addClass('row')
        .appendTo(photoContainer);

    loadMorePhotos(query);
}

const selectPhoto = url => {
    $('<form />').attr('method', 'post').attr('action', '/process/card/image-input')
        .append($('<input />').attr('name', 'url').attr('type', 'hidden').val(url))
        .appendTo($('body'))
        .submit()
}

const loadMorePhotos = query => {
    const row = photoContainer.find('.row')

    page++;

    getPhotos(query, page)
        .then(result => {
            result.hits.forEach(photo => {

                const filter = $('<div />')
                    .addClass('card-library-photo-filter')

                const col = $('<div />')
                    .addClass('col-6').addClass('col-lg-3').addClass('card-library-photo').addClass('my-2')
                    .appendTo(row)
                    .mouseenter(() => filter.show())
                    .mouseleave(() => filter.hide());

                filter.appendTo(col)
                    .on('click', () => {
                        showPreview(photo.largeImageURL)
                    });

                $('<button />')
                    .addClass('card-library-photo-filter-preview').addClass('card-library-photo-filter-button')
                    .text(photoContainer.attr('data-content-preview'))
                    .appendTo(filter)

                $('<img />')
                    .attr('src', photo.webformatURL)
                    .attr('alt', query)
                    .addClass('img-fluid')
                    .appendTo(col)
            })
        })
        .catch(err => console.error(err))
}

const showPreview = (src, author) => {
    const maxHeight = $(window).height() - 250
    const photo = $('<img />').attr('src', src)
        .addClass('img-fluid').css('max-height', `${maxHeight}px`)
        .on('click', () => selectPhoto(src));;
    $('#previewModal').modal('show').find('.modal-body').html(photo)
    $('#previewModal').find('.card-button').attr('href', '#').on('click', () => selectPhoto(src));
}

$(() => {
    renderPhoto(photoContainer.attr('data-query'));
    $('.card-library-more').on('click', () => loadMorePhotos(photoContainer.attr('data-query')))
})